// extracted by mini-css-extract-plugin
module.exports = {"SortIndicator":"SortIndicator_SortIndicator__2yihA"};